import Button from "../button/button";
import Typography from "../typography/typography";
import "./inventory-reports-title-bar.scss";

import TitleDropdownButton from "../title-dropdown-button/title-dropdown-button";
import { useEffect, useMemo, useRef, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { generateFields } from "../../utils/common";
import ReportButtons, { IReportButtons } from "./report-buttons/report-buttons";
import TabBar, { TabProps } from "../tabs/tabs";
import { Box, ButtonGroup, ClickAwayListener, Divider, Grow, Menu, MenuItem, Paper, Popper, Button as MuiButton } from "@mui/material";
import images from "../../assets/images";
import { enUS } from 'date-fns/locale'; // Import the desired locale
// import ReportFilter from './component/reportFilter'
import {
  handleCompareDateRangeSync as handleCompareDateRange,
  RANGE,
} from "../../utils/date-range";
import { DateRange, Calendar } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import dayjs from "dayjs";
// import {  fetchOptions } from "./redux/actionCreator";
import React from "react";
import HeaderCard from "../header-card/header-card";
import viewTypes from "../../constants/action-bar";
import SearchBar from "../search-bar/search-bar";
import Checkbox from "../checkbox/checkbox";
import SearchableSelect from "../searchable-select";
import { Filter as FilterIcon } from "../icons";

interface IReportFilters {
  company: number;
  start_date: string;
  end_date: string;
  as_of_date: string;
  item_id: string | number;
  warehouse_id: string | number;
  assembly_item_id: number | string;
  bom_id: number | string
}

/** Descriptor for a custom component injected into the filter row. */
interface ICustomFilterComponent {
  /** Unique key used for React reconciliation. */
  key: string;
  /** The ReactNode to render inside the filter bar. */
  component: React.ReactNode;
}

interface ActionBarPropsType extends Partial<TabProps>, IReportButtons {
  title: string;
  handleAddButton?: (e?: any) => void;
  isTitleMenu?: boolean;
  titleMenus?: any;
  reportFilterFields?: any[];
  isDateFilterEnabled?: boolean;
  onDateFilterChange?: (data: Partial<IReportFilters>) => void;
  filters?: Partial<IReportFilters>;
  isDateRange?: boolean;
  activeView?: string;
  setActiveView?: (string: string) => void;
  handleSearch?: (string: string) => void;
  showLevelBtn?: boolean;
  handleRowsExpand: () => void;
  handleRowsCollapse: () => void;
  customElement?: React.ReactNode;
  showLeftContent: boolean;
  showAssembluItemsFilter?: boolean;
  showBomFilter: boolean;
  isViewButton?: boolean;
  handleRedirect?: () => void;
  buttonText?: string;
  dataLength: number,
  filterDropDown: any[],
  filterKeys?: any,
  customSelectedFilter?: any[],
  customFilterConfig?: any[],
  /**
   * When `false` the Date chip and the date-range dropdown button are hidden
   * and date-related keys (`start_date`, `end_date`, `as_of_date`) are stripped
   * from every filter payload so they cannot reach the API.
   * Defaults to `true` (backward-compatible).
   */
  showDateFilter?: boolean;
  /**
   * Optional list of custom components to render inside the filter row.
   * Each entry must have a unique `key` and a `component` (ReactNode).
   * They are appended after the standard SearchableSelect filters.
   */
  customFilterComponents?: ICustomFilterComponent[];
}

type TDatePickerVal = {
  startDate?: Date;
  endDate?: Date;
  key?: string;
};

const customStyle =
{

  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: 'none',
    },

    '&.Mui-focused fieldset': {
      border: 'none',
    },

  },
}
const InventoryReportsTitleBar = (props: ActionBarPropsType) => {
  const {
    title,
    handleAddButton,
    buttons = [],
    dropdownMenuButtonData,
    isTitleMenu = false,
    titleMenus = [],
    reportFilterFields = [],
    toggleCallback,
    tabs,
    activeValue,
    setActiveValue,
    isDateFilterEnabled,
    onDateFilterChange,
    filters = {},
    isDateRange = true,
    activeView = "",
    setActiveView,
    handleSearch,
    showLevelBtn = false,
    handleRowsExpand,
    handleRowsCollapse,
    customElement,
    showLeftContent = true,
    // showAssembluItemsFilter = false,
    // showBomFilter = false,
    isViewButton = false,
    handleRedirect,
    buttonText = '',
    dataLength,
    filterDropDown = [],
    filterKeys,
    customFilterConfig = [],
    customSelectedFilter = [],
    /** Hide the date chip and date-range dropdown when false. Defaults to true. */
    showDateFilter = true,
    /** Custom ReactNode components rendered after the standard filters. */
    customFilterComponents = [],
  } = props;

  // When `showDateFilter` is false, exclude the 'date' entry from the
  // default selection so the date chip is never active.
  const defaultSelectedFilter = [
    // Only include 'date' when the date field is enabled.
    ...(showDateFilter ? [{ value: 'date' }] : []),
    {
      value: 'location',
    },
    {
      value: 'company',
    },
  ]

  const defaultConfig = [
    {
      key: 'company',
      label: 'Search Company',
      placeholder: 'Company',
      apiType: 'company',
      valueKey: filterKeys?.['company'] ? filterKeys['company'] : 'company',
      customFilter: null,
    },
    {
      key: 'assembly_item',
      label: 'Search Assembaly Items',
      placeholder: 'Assembaly Items',
      apiType: 'assemblyItems',
      valueKey: filterKeys?.['assembly_item'] ? filterKeys['assembly_item'] : 'assembly_item_id',
    },
    {
      key: 'item',
      label: 'Search Items',
      placeholder: 'Items',
      apiType: 'reportItems',
      valueKey: filterKeys?.['item'] ? filterKeys['item'] : 'item_id',
      multiple: true
    },
    {
      key: 'location',
      label: 'Search Warehouse Location',
      placeholder: 'Warehouse Location',
      apiType: 'location',
      valueKey: filterKeys?.['location'] ? filterKeys['location'] : 'warehouse_id',
      customFilter: null,
      multiple: true

    },
    {
      key: 'bom',
      label: 'Search Bill of Materials',
      placeholder: 'Filter Bill of Materials',
      apiType: 'bom',
      valueKey: filterKeys?.['bom'] ? filterKeys['bom'] : 'bom_id',
      customFilter: null,
      multiple: true
    },
    {
      key: 'work_order',
      label: 'Search Work Order',
      placeholder: ' Work Order',
      apiType: 'workOrder',
      valueKey: filterKeys?.['work_order'] ? filterKeys['work_order'] : 'work_order_id',
      customFilter: null,
      multiple: true
    },
    {
      key: 'routing',
      label: 'Search Routing',
      placeholder: ' Routing',
      apiType: 'routing',
      valueKey: filterKeys?.['routing'] ? filterKeys['routing'] : 'routing_id',
      customFilter: null,
      multiple: true
    },
    {
      key: 'operation',
      label: 'Search Operation',
      placeholder: ' Operation',
      apiType: 'operations',
      valueKey: filterKeys?.['operation'] ? filterKeys['operation'] : 'operation_id',
      customFilter: null,
      multiple: true
    },
    {
      key: 'equipment',
      label: 'Search Equipment',
      placeholder: ' Equipment',
      apiType: 'equipment',
      valueKey: filterKeys?.['equipment'] ? filterKeys['equipment'] : 'equipment_id',
      customFilter: null,
      multiple: true
    },
    {
      key: 'work_center',
      label: 'Search Work Center',
      placeholder: ' Work Center',
      apiType: 'workCenter',
      valueKey: filterKeys?.['work_center'] ? filterKeys['work_center'] : 'work_center_id',
      customFilter: null,
      multiple: true
    },

  ]
  const filtersConfig = useMemo(() => {
    return [...defaultConfig, ...customFilterConfig]
  }, []);
  const inputStyle =
  {
    border: "none",
    "&.Mui-focused": {
      borderColor: "transparent",
    },
    "& .MuiOutlinedInput-input": {
      padding: "0px",
      fontSize: "14px",
      color: '#289b64'
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    '& .MuiSelect-icon': {
      color: 'green',
    },
  }


  /**
   * Wraps `onDateFilterChange` to strip date-related keys when
   * `showDateFilter` is false, guaranteeing they never reach the API.
   * Defined before `renderFilter` to avoid temporal dead zone errors.
   */
  const safeOnDateFilterChange = (data: Partial<IReportFilters>) => {
    if (!onDateFilterChange) return;
    if (showDateFilter) {
      onDateFilterChange(data);
    } else {
      // Strip all date fields so they cannot pollute the request payload.
      const { start_date, end_date, as_of_date, ...rest } = data;
      onDateFilterChange(rest as Partial<IReportFilters>);
    }
  };

  const renderFilter = ({
    key,
    label,
    placeholder,
    apiType,
    valueKey,
    customFilter,
    multiple = false
  }: any) => {
    if (!showFilter(key)) return null;

    return (
      <div className="search-filter" key={key}>
        <SearchableSelect
          labelId={`${key}-label`}
          searchPlaceholder={label}
          value={filters?.[valueKey]}
          onChange={(e) => safeOnDateFilterChange({ [valueKey]: e.target.value } as Partial<IReportFilters>)}
          apiType={apiType}
          multiple={multiple}
          placeholder={placeholder}
          customeFilter={customFilter}
          // CustomDropDownIcon={FilterAltIcon}
          customStyle={customStyle}
          inputStyle={inputStyle}
        />
      </div>
    );
  };
  // const dispatch = useAppDispatch();

  const FilterContainer = () => (
    <>
      {filtersConfig.map(renderFilter)}
      {/* Render any custom components injected by the consumer */}
      {customFilterComponents.map(({ key, component }) => (
        <React.Fragment key={key}>{component}</React.Fragment>
      ))}
    </>
  );




  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
  const [allFields, setAllFields] = useState<any[]>([]);
  const [dateRange, setDateRange] = useState<keyof typeof RANGE>("TODAY");
  const [open, setOpen] = useState<boolean>(false);
  const [customDate, setCustomDate] = useState<Date>(
    new Date(dayjs(filters?.as_of_date || "").format("YYYY-MM-DD"))
  );

  const defaultSelected = useMemo(() => {
    return [...defaultSelectedFilter, ...customSelectedFilter]
  }, [])
  const [selectedItems, setSelectedItems] = useState<string[]>(defaultSelected);

  const [level, setLevel] = useState<number>(1)
  const [customDateRange, setCustomDateRange] = useState<TDatePickerVal>({
    startDate: new Date(dayjs(filters?.start_date || "").format("YYYY-MM-DD")),
    endDate: new Date(dayjs(filters?.end_date || "").format("YYYY-MM-DD")),
    key: "selection",
  });
  const anchorRef = useRef<HTMLDivElement | null>(null);
  const [actionAnchorEl, setActionAnchorEl] = useState<null | HTMLElement>(
    null
  );

  const dateSelectRef = useRef<HTMLDivElement>(null);
  const chipDateSelectRef = useRef<HTMLDivElement>(null);

  const handleCloseDatePopper = () => {
    anchorRef.current = null;
    setOpen(false);
  };

  const handleDateChange = (range: keyof typeof RANGE) => {
    // Do nothing if the date filter is hidden — guard against programmatic calls.
    if (!showDateFilter) return;
    setDateRange(range);
    if (range === "CUSTOM") {
      anchorRef.current = dateSelectRef.current;
      setOpen(true);
    } else {
      const data = handleCompareDateRange({
        range: RANGE[range],
        from: "",
        to: "",
      });
      safeOnDateFilterChange({
        start_date: data?.from ? data?.from : "",
        end_date: data?.to ? data?.to : "",
      });
      handleCloseDatePopper();
    }
  };


  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    handleCloseDatePopper();
  };

  const options = [
    {
      label: RANGE.TODAY,
      callback: () => {
        handleDateChange("TODAY");
      },
    },
    {
      label: RANGE.THIS_WEEK,
      callback: () => {
        handleDateChange("THIS_WEEK");
      },
    },
    {
      label: RANGE.THIS_MONTH,
      callback: () => {
        handleDateChange("THIS_MONTH");
      },
    },
    {
      label: RANGE.THIS_QUARTER,
      callback: () => {
        handleDateChange("THIS_QUARTER");
      },
    },
    {
      label: RANGE.THIS_YEAR,
      callback: () => {
        handleDateChange("THIS_YEAR");
      },
    },
    {
      label: RANGE.YESTERDAY,
      callback: () => {
        handleDateChange("YESTERDAY");
      },
    },
    {
      label: RANGE.PREVIOUS_WEEK,
      callback: () => {
        handleDateChange("PREVIOUS_WEEK");
      },
    },
    {
      label: RANGE.PREVIOUS_MONTH,
      callback: () => {
        handleDateChange("PREVIOUS_MONTH");
      },
    },
    {
      label: RANGE.PREVIOUS_QUARTER,
      callback: () => {
        handleDateChange("PREVIOUS_QUARTER");
      },
    },
    {
      label: RANGE.PREVIOUS_YEAR,
      callback: () => {
        handleDateChange("PREVIOUS_YEAR");
      },
    },
    {
      label: RANGE.CUSTOM,
      callback: () => {
        handleDateChange("CUSTOM");
      },
    },
  ];

  const isChecked = (value: any) => {
    return selectedItems.some(item => item?.value == value?.value)
  }

  const handleFilterPopperSubmit = () => {
    const dateRangeFilter = {
      start_date: dayjs(customDateRange.startDate).format("YYYY-MM-DD"),
      end_date: dayjs(customDateRange.endDate).format("YYYY-MM-DD"),
    };
    const dateFilter = {
      as_of_date: dayjs(customDate).format("YYYY-MM-DD"),
    };

    // Use safeOnDateFilterChange so date keys are stripped when showDateFilter is false.
    safeOnDateFilterChange({
      ...(isDateRange ? dateRangeFilter : dateFilter),
    });
    handleCloseDatePopper();
  };
  const handleFilterClose = () => {
    setActionAnchorEl(null);
  };
  const handleSelectChange = (value: any) => {
    if (selectedItems.some((item) => item.value == value.value)) {
      setSelectedItems(selectedItems.filter((item) => item?.value != value.value));
      return;
    }
    setSelectedItems([...selectedItems, value]);
  };
  function showFilter(val) {
    return selectedItems.some(item => item?.value == val)
  }
  const filterDropDownFunc = () => {
    return (
      <Menu
        anchorEl={actionAnchorEl}
        open={Boolean(actionAnchorEl)}
        onClose={handleFilterClose}
      >
        {/* <MenuItem className="inventoryReportsTitleBar--report-filter"> */}
        {/* Add your options here */}
        {filterDropDown?.map((item) => (
          <MenuItem onClick={() => handleSelectChange(item)} key={item} value={item?.value}>
            <Checkbox checked={isChecked(item)} />
            <Typography sx={{ marginLeft: '10px' }} color='theme.neutral.800' type='s3'>{item?.name}</Typography>
          </MenuItem>
        ))}
        {/* </MenuItem> */}
      </Menu>
    );
  };
  useEffect(() => {
    setCustomDate(
      new Date(dayjs(filters?.as_of_date || "").format("YYYY-MM-DD"))
    );
  }, [filters?.as_of_date]);

  useEffect(() => {
    setCustomDateRange({
      ...customDateRange,
      startDate: new Date(
        dayjs(filters?.start_date || "").format("YYYY-MM-DD")
      ),
      endDate: new Date(dayjs(filters?.end_date || "").format("YYYY-MM-DD")),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters?.end_date, filters?.start_date]);

  useEffect(() => {
    if (open) {
      if (isDateRange) {
        setCustomDateRange({
          ...customDateRange,
          startDate: new Date(
            dayjs(filters?.start_date || "").format("YYYY-MM-DD")
          ),
          endDate: new Date(
            dayjs(filters?.end_date || "").format("YYYY-MM-DD")
          ),
        });
      } else {
        setCustomDate(
          new Date(dayjs(filters?.as_of_date || "").format("YYYY-MM-DD"))
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, isDateRange]);

  // useEffect(() => {
  //   // dispatch(fetchOptions());
  //   if (showBomFilter) {
  //     dispatch(fetchBom())
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    setAllFields(generateFields(reportFilterFields));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportFilterFields]);

  return (
    <div>
      <div className="inventoryReportsTitleBar">
        {showLeftContent && <div className="inventoryReportsTitleBar--LeftContent">
          {isTitleMenu ? (
            <div style={{ zIndex: 999 }}>
              <TitleDropdownButton
                onClick={handleAddButton}
                options={titleMenus}
                isMenuThirdItemDisabled={true}
              >
                {title}
              </TitleDropdownButton>
            </div>
          ) : (
            <Typography type="h3" weight="medium" color="theme.secondary.1000">
              {title}
            </Typography>
          )}
          {[
            { label: viewTypes.TABLE, position: 1 },
            { label: viewTypes.CHART, position: 2 },
          ]
            .map((ele) => ele)
            .sort((a, b) => a.position - b.position)
            .map((item) => (
              <HeaderCard
                key={item?.position}
                title={item?.label}
                active={activeView}
                onClick={() => setActiveView?.(item.label)}
              />
            ))}

        </div>}
        {isViewButton &&
          <div className="inventoryReportsTitleBar--ExtraButtonUi">
            <Button onClick={handleRedirect} >{buttonText}</Button>
          </div>
        }
        <ReportButtons
          zIndex={999}
          className="inventoryReportsTitleBar--RightContent"
          buttons={buttons}
          dropdownMenuButtonData={dropdownMenuButtonData}
          toggleCallback={toggleCallback}
          variant={"contained"}
          iconPosition="end"
        />
        {customElement && <Box >
          {customElement}
        </Box>}

      </div>
      <Divider sx={{ mb: 2, mx: 1, borderColor: 'grey.200' }} />

      {tabs?.length ? (
        <div>
          <TabBar
            tabs={tabs || []}
            activeValue={activeValue}
            setActiveValue={setActiveValue}
          />
        </div>
      ) : null}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: 1,
          flexWrap: 'wrap',
          mx: 1
        }}
      >
        <div className="inventoryReportsTitleBar--FilterWrapper">

          {/* Date range chip — hidden when showDateFilter is false */}
          {showDateFilter && showFilter('date') && isDateRange && (
            <div style={{ display: "flex", gap: "8px" }}>
              <div
                className="inventoryReportsTitleBar--FilterWrapper--Chip"
                ref={chipDateSelectRef}
                onClick={() => {
                  if (!open) {
                    anchorRef.current = chipDateSelectRef.current;
                    setOpen(true);
                  } else {
                    handleCloseDatePopper();
                  }
                }}
              >
                <div
                  className="inventoryReportsTitleBar--FilterWrapper--Chip--Text"
                  title={`${dayjs(filters?.start_date).format("DD/MM/YYYY")} - ${dayjs(filters?.end_date).format("DD/MM/YYYY")}`}
                >
                  <Typography type="s4" weight="medium">
                    Date Range:
                  </Typography>
                  <Typography
                    className="inventoryReportsTitleBar--FilterWrapper--Chip--Text--Value"
                    type="s4"
                  >
                    {dayjs(filters?.start_date).format("DD/MM/YYYY")} -{" "}
                    {dayjs(filters?.end_date).format("DD/MM/YYYY")}
                  </Typography>
                </div>
                <KeyboardArrowDownIcon />
              </div>
            </div>
          )}
          {/* As-of-date chip — hidden when showDateFilter is false */}
          {showDateFilter && showFilter('date') && filters?.as_of_date && !isDateRange && (
            <div style={{ display: "flex", gap: "8px" }}>
              <div
                className="inventoryReportsTitleBar--FilterWrapper--Chip"
                ref={chipDateSelectRef}
                onClick={() => {
                  if (!open) {
                    anchorRef.current = chipDateSelectRef.current;
                    setOpen(true);
                  } else {
                    handleCloseDatePopper();
                  }
                }}
              >
                <div
                  className="inventoryReportsTitleBar--FilterWrapper--Chip--Text"
                  title={`${dayjs(filters?.as_of_date).format("DD/MM/YYYY")}`}
                >
                  <Typography type="s4" weight="medium">
                    Date:
                  </Typography>
                  <Typography
                    className="inventoryReportsTitleBar--FilterWrapper--Chip--Text--Value"
                    type="s4"
                  >
                    {dayjs(filters?.as_of_date).format("DD/MM/YYYY")}
                  </Typography>
                </div>
                <KeyboardArrowDownIcon />
              </div>
            </div>
          )}
          {FilterContainer()}
        </div>


        {/* Date-range dropdown button — only shown when both isDateFilterEnabled AND showDateFilter are true */}
        {isDateFilterEnabled && showDateFilter && <div className="inventoryReportsTitleBar--FilterAction">
          (
          <>
            <ReportButtons
              zIndex={997}
              className="inventoryReportsTitleBar--RightContent"
              dropdownMenuButtonData={{
                icon: <img src={images.sidebar.calendar2} />,
                children: (
                  <>
                    {RANGE[dateRange]}
                    <KeyboardArrowDownIcon />
                  </>
                ),
                options: options,
              }}
              toggleCallback={toggleCallback}
            />
            <div ref={dateSelectRef}></div>
          </>
          )
        </div>
        }
        <div className="inventoryReportsTitleBar--FilterAction">
          <Button
            sx={({ palette }) => ({
              border: "1px solid",
              borderColor: 'grey.200',
              borderRadius: "50px",
              color: `${palette.grey[800]} !important`,
              '&:hover': {
                bgcolor: `${palette.grey[200]} !important`,
              }
            })}
            variant="text"
            startIcon={<FilterIcon fontSize="small" />}
            onClick={(event) => setActionAnchorEl(event.currentTarget)}
          >
            Filter
          </Button>
          {showLevelBtn && <Divider flexItem orientation="vertical" sx={{ alignSelf: 'auto' }} />}
          {filterDropDownFunc()}
          {showLevelBtn && (
            <>
              <Box className="inventoryReportsTitleBar--FilterAction--lvWrapper">
                <Typography type="s3" weight="medium" color='grey.800'> Level {level} of {dataLength}</Typography>
                <ButtonGroup variant="outlined" disableElevation sx={({ palette }) => ({
                  '& .MuiButton-root': {
                    borderColor: `${palette.grey[200]} !important`,
                    '&:hover': {
                      bgcolor: `${palette.grey[200]} !important`,
                    }
                  },
                  '& .MuiButtonGroup-firstButton': {
                    borderTopLeftRadius: 20,
                    borderBottomLeftRadius: 20
                  },
                  '& .MuiButtonGroup-lastButton': {
                    borderTopRightRadius: 20,
                    borderBottomRightRadius: 20
                  }
                })}>
                  <MuiButton onClick={() => {
                    setLevel(level == dataLength ? level : level + 1)
                    handleRowsCollapse?.(level)
                  }}>
                    <img src={images.common.expand} />
                  </MuiButton>
                  <MuiButton onClick={() => {
                    setLevel(level != 1 ? level - 1 : 1)
                    handleRowsExpand?.(level)
                  }}>
                    <img src={images.common.collapse} />
                  </MuiButton>
                </ButtonGroup>
              </Box>
            </>
          )}
          <SearchBar
            placeholder="Search"
            handleSearch={(val) => handleSearch?.(val)}
            sx={{
              width: "250px",
              background: "#fff !important",
              border: "1px solid #F3F2F2 !important",
            }}
          />
        </div>
      </Box>

      <Divider sx={{ my: 2, mx: 1, borderColor: 'grey.200' }} />

      <Popper
        sx={{
          zIndex: 9999,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              margin: "0 20px 0 20px",
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                  }}
                >
                  <div>
                    {isDateRange ? (
                      <DateRange
                        editableDateInputs={true}
                        onChange={(item) => setCustomDateRange(item.selection)}
                        moveRangeOnFirstSelection={false}
                        ranges={[customDateRange]}
                        locale={enUS}
                      />
                    ) : (
                      <Calendar
                        onChange={(item) => setCustomDate(item)}
                        date={customDate}
                        locale={enUS}
                      />
                    )}
                  </div>
                  <Box sx={{ padding: "0 12px 12px 0" }}>
                    <Button
                      variant="contained"
                      sx={{ width: "fit-content" }}
                      onClick={handleFilterPopperSubmit}
                    >
                      Apply
                    </Button>
                  </Box>
                </Box>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

    </div>
  );
};

export { InventoryReportsTitleBar };
export default InventoryReportsTitleBar;
